/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { RecurrenceRequest } from './recurrenceRequest';

/**
 * Optional recurrence pattern
 */
export type CreateSlotsRequestRecurrence = RecurrenceRequest | null;
